import React, { useRef, useState, useEffect } from 'react';

/**
 * LazySection — delays rendering children until the section is near the viewport.
 * Keeps initial JS parse + paint cost low for below-fold sections.
 */
const LazySection = ({ children, rootMargin = '300px', className = '' }) => {
    const ref     = useRef(null);
    const [shown, setShown] = useState(false);

    useEffect(() => {
        const el = ref.current;
        if (!el) return;

        // If browser doesn't support IO, just show immediately
        if (!('IntersectionObserver' in window)) {
            setShown(true);
            return;
        }

        const io = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setShown(true);
                    io.disconnect();
                }
            },
            { rootMargin }
        );

        io.observe(el);
        return () => io.disconnect();
    }, [rootMargin]);

    return (
        <div ref={ref} className={className}>
            {shown ? children : null}
        </div>
    );
};

export default LazySection;
